import LdsIcon from '../LdsIcon/index.jsx';
export default function ExpandButton({
  index,
  itemText,
  iconName = '',
  iconPosition = 'after',
  megaMenu,
  expanded,
  menuType,
  controlId,
}) {
  return (
    <>
      <div className="lds-header-menu-item-button">
        <button
          aria-labelledby={`header-menu-item-${menuType}-${index}`}
          aria-controls={controlId}
          data-testid={`header-menu-button-${itemText.replace(/\s+/g, '-')}`}
          type="button"
          className="lds-button-base"
          aria-expanded={expanded}
          tabIndex="0"
        />
        <span
          id={`header-menu-item-${menuType}-${index}`}
          aria-hidden="true"
          className="lds-header-menu-item-link-text"
        >
          {iconName.length > 0 && iconPosition === 'before' && (
            <>
            <LdsIcon name={iconName} inline decorative />
            &nbsp;
            </>
          )}
          <span dangerouslySetInnerHTML={{ __html: itemText }}/>
          {iconName.length > 0 && iconPosition !== 'before' && (
            <>
            &nbsp;
            <LdsIcon name={iconName} inline decorative />
            </>
          )}
        </span>
      </div>

      <div
        className={`lds-header-menu-item-toggle ${
          megaMenu ? '' : 'will-rotate'
        }`}
      >
        <div className="lds-header-menu-item-icon-mega-menu-mobile">
          <LdsIcon decorative inline name="CaretRight" />
        </div>
        <div className="lds-header-menu-item-icon-default">
          <LdsIcon decorative inline name="CaretDown" />
        </div>
      </div>
    </>
  );
}
